"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var dayjs_1 = __importDefault(require("dayjs"));
var ramda_1 = require("ramda");
var constants_1 = require("./constants");
var api_1 = require("../../utils/api");
var reducers = {
    accountPinValidation: api_1.createCustomModuleReducer(__assign(__assign({}, api_1.createApiReducer({
        actionType: constants_1.VALIDATE_ACCOUNT_PIN,
        onSuccess: function (draftState, action) {
            var _a;
            var _b = action.meta, userProfileId = _b.userProfileId, lastEnteredPin = _b.lastEnteredPin;
            draftState.data[userProfileId] = {
                pinValidationResult: (_a = action.payload) === null || _a === void 0 ? void 0 : _a.validatePin,
                expiryDate: dayjs_1.default().add(1, 'seconds'),
                lastEnteredPin: lastEnteredPin,
            };
        },
    })), (_a = {}, _a[constants_1.CLEAR_VALIDATE_ACCOUNT_PIN] = function (draftState, action) {
        var userProfileId = action.payload.userProfileId;
        if (ramda_1.isNil(draftState.data[userProfileId]) || ramda_1.isNil(userProfileId)) {
            return;
        }
        draftState.data[userProfileId].pinValidationResult = {};
        draftState.data[userProfileId].expiryDate = null;
    }, _a)), api_1.createApiInitialState({})),
};
exports.default = redux_1.combineReducers(reducers);
//# sourceMappingURL=reducer.js.map